/* eslint-disable*/
/* eslint-disable no-else-return */
/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable array-callback-return */
/* eslint-disable func-names */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable dot-notation */
import axios from 'axios';
import { toast } from 'react-toastify';
// import { useSnackbar } from 'notistack';
// config
import { HOST_API } from '../config';
import { getClientMode, logoutUser } from '.';
import { ShowNotistack, useNotification } from './showNotistack';

import { PATH_DASHBOARD } from '../routes/paths';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({
  baseURL: `${HOST_API}/api`,
});

axiosInstance.interceptors.response.use(
  (response) => response,
  // (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
  (error) => {
    // const { enqueueSnackbar } = useSnackbar();
    // const { showError } = useNotification(); // Use the notification service

    console.log('* * * axiosInstance : ', { error });
    if (error.response) {
      if (error.response.status !== 404) {
        if (error.response.status === 401) {
          logoutUser();
          window.location.href = '/auth/login';
        } else if (error.response.status === 403) {
          window.location.href = PATH_DASHBOARD.root;
        }else if (error.response.status === 500) {
          // do nothing
        } else {
          const errors = Object.values(error?.response?.data?.errors || {});
          if (errors?.length) {
            errors?.map((x) => {
              return toast.error(x?.[0]);
            });
          } else
            toast.error(
              error.response.data?.message || error.response.data?.error
            );
        }
      }
    } else {
      // if (error?.message == 'Network Error') toast.error('مشکل اتصال به اینترنت.');
      // else toast.error('مشکلی در ارتباط با سرور رخ داده است.');
    }

    if (error.response) {
      return Promise.reject(error);
    } else {
      return Promise.reject(error);
    }
  }
  // }
);

export default axiosInstance;
